<template>
    <div ref="scroller" class="listener-artists" @scroll.passive="listenBottomOut">
        <section class="listener-artists__hero">
            <div class="listener-artists__header">
                <div>
                    <div class="listener-artists__eyebrow">{{ $tt('艺术家收藏') }}</div>
                    <h1 class="listener-artists__title">{{ pageTitle }}</h1>
                </div>
                <button
                    class="listener-artists__refresh"
                    :disabled="loading"
                    :title="$tt('刷新')"
                    @click="refreshCurrentPage"
                >
                <svg t="1781507668775" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2332" width="250" height="250"><path d="M797.538462 699.648h-27.569231a319.744 319.744 0 0 0 61.873231-188.908308A320.157538 320.157538 0 0 0 512.059077 190.976a39.384615 39.384615 0 0 0-39.384615 39.384615 39.384615 39.384615 0 0 0 39.384615 39.384616 241.289846 241.289846 0 0 1 241.014154 240.994461 240.955077 240.955077 0 0 1-46.020923 141.469539v-44.228923a39.384615 39.384615 0 0 0-39.384616-39.384616 39.384615 39.384615 0 0 0-39.384615 39.384616v131.052307a39.384615 39.384615 0 0 0 39.384615 39.384616h129.969231a39.384615 39.384615 0 0 0 39.384615-39.384616 39.384615 39.384615 0 0 0-39.483076-39.384615z" fill="#333333" p-id="2333"></path><path d="M512 754.235077a241.250462 241.250462 0 0 1-240.994462-240.974769 240.817231 240.817231 0 0 1 46.020924-141.371077v38.006154a39.384615 39.384615 0 0 0 39.384615 39.384615 39.384615 39.384615 0 0 0 39.384615-39.384615V278.843077a39.384615 39.384615 0 0 0-39.384615-39.384615h-129.969231a39.384615 39.384615 0 0 0-39.384615 39.384615 39.384615 39.384615 0 0 0 39.384615 39.384615h32.393846a319.369846 319.369846 0 0 0-66.619077 194.953846 320.118154 320.118154 0 0 0 319.763693 319.744 39.384615 39.384615 0 0 0 39.384615-39.384615A39.384615 39.384615 0 0 0 512 754.235077z" fill="#333333" p-id="2334"></path></svg>
                </button>
            </div>

            <div class="listener-artists__tabs">
                <button
                    v-for="{ value, text } in options"
                    :key="value"
                    :class="['listener-artists__tab', sortValue === value ? 'is-active' : '']"
                    @click="switchSort(value)"
                >
                    {{ $tt(text) }}
                </button>
            </div>

            <div class="listener-artists__summary">
                <div class="listener-artists__summary-kicker">{{ $tt('当前视图') }}</div>
                <div class="listener-artists__summary-title">{{ pageTitle }}</div>
                <div class="listener-artists__summary-sub">{{ summaryText }}</div>
                <div v-if="items.length" class="listener-artists__actions">
                    <button class="listener-artists__action listener-artists__action--primary" @click="playArtist(items[0].id)">
                        <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M8 5.14v13.72a1 1 0 0 0 1.5.86l10-6.86a1 1 0 0 0 0-1.72l-10-6.86A1 1 0 0 0 8 5.14z"></path>
                        </svg>
                        <span>{{ $tt('播放第一位') }}</span>
                    </button>
                    <button class="listener-artists__action" @click="playRandomArtist">
                        <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M17 3h4v4h-2V6.41l-3.29 3.3-1.42-1.42L17.59 5H17V3zM3 7h5l3.29 3.29-1.42 1.42L7.17 9H3V7zm18 10v4h-4v-2h.59l-3.3-3.29 1.42-1.42 3.29 3.3V17H21zM3 15h4.17l10-10H21V3h-4v2h.59L7.17 15H3v2z"></path>
                        </svg>
                        <span>{{ $tt('随机一位') }}</span>
                    </button>
                </div>
            </div>
        </section>

        <section v-if="items.length" class="listener-artists__section">
            <div class="listener-artists__list">
                <article
                    v-for="artist in items"
                    :key="artist.id"
                    class="listener-artists__row"
                >
                    <button class="listener-artists__main" @click="openArtist(artist)">
                        <img
                            :src="artist.image || '/static/dist/img/album_null.jpg'"
                            :alt="artist.name"
                            class="listener-artists__image"
                        >
                        <div class="listener-artists__meta">
                            <div class="listener-artists__name">{{ artist.name }}</div>
                            <div class="listener-artists__sub">
                                {{ $tt('{count} 张专辑', { count: artist.albumCount || 0 }) }}
                                <span v-if="artist.trackCount"> · {{ artist.trackCount }} {{ $tt('首歌曲') }}</span>
                            </div>
                        </div>
                    </button>
                    <button class="listener-artists__play" @click.stop="playArtist(artist.id)">
                        <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M8 5.14v13.72a1 1 0 0 0 1.5.86l10-6.86a1 1 0 0 0 0-1.72l-10-6.86A1 1 0 0 0 8 5.14z"></path>
                        </svg>
                    </button>
                </article>
            </div>
        </section>

        <section v-else-if="!loading" class="listener-artists__empty">
            <div class="listener-artists__empty-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                    <path d="M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm0 2c-3.314 0-6 1.79-6 4v1h12v-1c0-2.21-2.686-4-6-4z"></path>
                </svg>
            </div>
            <h2>{{ $tt('还没有艺术家') }}</h2>
            <p>{{ $tt('这个分类下暂时没有内容，切换一个筛选看看。') }}</p>
        </section>

        <section v-if="loading" class="listener-artists__state">
            <div class="listener-artists__loading"></div>
            <p>{{ $tt('正在加载...') }}</p>
        </section>
    </div>
</template>

<script>
export default {
    name: 'ListenerArtistLibrary',
    data() {
        return {
            loading: false,
            options: [
                { text: '最多专辑', value: 'most-albums' },
                { text: 'A-Z排序', value: 'a-z' },
                { text: '缺失封面', value: 'less_cover' }
            ],
            items: [],
            offset: 0,
            hasMore: true,
            curScrollTop: 0,
            watchSearchTerm: null,
            searchTimeout: null
        }
    },
    computed: {
        sortValue() {
            return this.$route.params.sort || 'most-albums'
        },
        pageTitle() {
            const current = this.options.find(item => item.value === this.sortValue)
            return current ? this.$tt(current.text) : this.$tt('艺术家')
        },
        summaryText() {
            const map = {
                'most-albums': this.$tt('优先查看作品最多的艺术家，适合顺着专辑量往下听。'),
                'a-z': this.$tt('按名称浏览艺术家列表，找人会更直接。'),
                'less_cover': this.$tt('这里是还缺封面的艺术家，后续可以继续补全。')
            }
            return map[this.sortValue] || this.$tt('切换不同预设，快速浏览你的艺术家收藏。')
        },
        getSearchTerm() {
            return this.$store.getters.getSearchTerm
        }
    },
    created() {
        this.loadMore()
    },
    activated() {
        this.$nextTick(() => {
            if (this.$refs.scroller) {
                this.$refs.scroller.scrollTop = this.curScrollTop || 0
            }
        })
        this.startWatching()
    },
    deactivated() {
        this.stopWatching()
    },
    beforeDestroy() {
        this.stopWatching()
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout)
            this.searchTimeout = null
        }
    },
    methods: {
        resetState() {
            this.items = []
            this.offset = 0
            this.hasMore = true
            this.curScrollTop = 0
            if (this.$refs.scroller) {
                this.$refs.scroller.scrollTop = 0
            }
        },
        refreshCurrentPage() {
            if (this.loading) {
                return
            }
            this.resetState()
            if (this.getSearchTerm) {
                return this.loadSearch()
            }
            return this.loadMore()
        },
        startWatching() {
            if (!this.watchSearchTerm) {
                this.watchSearchTerm = this.$watch('getSearchTerm', this.loadSearchTimeout)
            }
        },
        stopWatching() {
            if (this.watchSearchTerm) {
                this.watchSearchTerm()
                this.watchSearchTerm = null
            }
        },
        loadSearch() {
            if (this.getSearchTerm === '') {
                this.items = []
                this.offset = 0
                this.hasMore = true
                this.loading = false
                if (this.$refs.scroller) {
                    this.$refs.scroller.scrollTop = 0
                }
                return this.loadMore()
            }
            this.loading = true
            this.offset = 0
            this.hasMore = false
            this.$api.subsonic.searchArtists('search', this.getSearchTerm).then(artists => {
                this.items = artists
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        loadSearchTimeout() {
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout)
            }
            this.searchTimeout = setTimeout(() => {
                this.searchTimeout = null
                this.loadSearch()
            }, 300)
        },
        loadMore() {
            if (this.loading || !this.hasMore || this.getSearchTerm) {
                return
            }
            this.loading = true
            return this.$api.subsonic.getArtists(this.sortValue, 30, this.offset).then(artists => {
                this.items.push(...artists)
                this.offset += artists.length
                this.hasMore = artists.length > 0
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        listenBottomOut() {
            if (!this.hasMore || this.loading || !this.$refs.scroller || this.getSearchTerm) {
                return
            }
            const scroller = this.$refs.scroller
            this.curScrollTop = scroller.scrollTop
            if (scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 120) {
                this.loadMore()
            }
        },
        switchSort(value) {
            if (value === this.sortValue) {
                return
            }
            this.$router.push({ path: '/artists/' + value })
        },
        openArtist(item) {
            this.$router.push({ path: '/artist/id/' + item.id })
        },
        async playArtist(id) {
            const tracks = await this.$api.subsonic.getTracksByArtist(id)
            return this.$store.dispatch('playTrackList', {
                tracks
            })
        },
        playRandomArtist() {
            if (!this.items.length) {
                return
            }
            const target = this.items[Math.floor(Math.random() * this.items.length)]
            this.playArtist(target.id)
        }
    }
}
</script>

<style scoped>
.listener-artists {
    height: calc(100dvh - 12.25rem);
    padding: 0.45rem 0.1rem 0.25rem;
    box-sizing: border-box;
    overflow-y: auto;
}

.listener-artists__hero {
    padding: 0.3rem 0.25rem 0.2rem;
}

.listener-artists__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    margin-bottom: 1rem;
}

.listener-artists__eyebrow {
    font-size: 0.85rem;
    font-weight: 700;
    color: #94a3b8;
    letter-spacing: 0.04em;
}

.listener-artists__title {
    margin-top: 0.2rem;
    font-size: 2rem;
    line-height: 1;
    font-weight: 800;
    color: #111827;
    letter-spacing: -0.04em;
}

.listener-artists__refresh {
    width: 2.8rem;
    height: 2.8rem;
    border: 0;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.84);
    color: #0f172a;
    box-shadow: 0 12px 26px rgba(148, 163, 184, 0.14);
}

.listener-artists__refresh:disabled {
    opacity: 0.6;
}

.listener-artists__refresh svg {
    width: 2rem;
    height: 1.5rem;
}

.listener-artists__tabs {
    display: flex;
    gap: 0.55rem;
    overflow-x: auto;
    padding-bottom: 0.15rem;
    scrollbar-width: none;
}

.listener-artists__tabs::-webkit-scrollbar {
    display: none;
}

.listener-artists__tab {
    border: 0;
    border-radius: 999px;
    padding: 0.72rem 0.9rem;
    white-space: nowrap;
    background: rgba(255, 255, 255, 0.85);
    color: #64748b;
    font-size: 0.84rem;
    font-weight: 700;
    box-shadow: 0 10px 24px rgba(148, 163, 184, 0.1);
}

.listener-artists__tab.is-active {
    background: #111827;
    color: #fff;
    box-shadow: 0 16px 30px rgba(15, 23, 42, 0.2);
}

.listener-artists__summary {
    margin-top: 0.95rem;
    padding: 1rem;
    border-radius: 1.65rem;
    background: linear-gradient(135deg, rgba(17, 24, 39, 0.96), rgba(55, 65, 81, 0.92));
    color: #fff;
    box-shadow: 0 20px 46px rgba(15, 23, 42, 0.16);
}

.listener-artists__summary-kicker {
    font-size: 0.72rem;
    color: rgba(255, 255, 255, 0.64);
}

.listener-artists__summary-title {
    margin-top: 0.35rem;
    font-size: 1.08rem;
    font-weight: 700;
    line-height: 1.4;
}

.listener-artists__summary-sub {
    margin-top: 0.32rem;
    font-size: 0.8rem;
    line-height: 1.55;
    color: rgba(255, 255, 255, 0.68);
}

.listener-artists__actions {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.65rem;
    margin-top: 0.9rem;
}

.listener-artists__action {
    border: 0;
    border-radius: 1rem;
    padding: 0.78rem 0.65rem;
    background: rgba(255, 255, 255, 0.12);
    color: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.45rem;
    font-size: 0.82rem;
    font-weight: 700;
}

.listener-artists__action--primary {
    background: #fff;
    color: #111827;
}

.listener-artists__action svg {
    width: 1.02rem;
    height: 1.02rem;
}

.listener-artists__section {
    margin-top: 1rem;
}

.listener-artists__list {
    display: grid;
    gap: 0.8rem;
    padding: 0 0.25rem 0.75rem;
}

.listener-artists__row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 0.75rem;
    align-items: center;
    padding: 0.75rem;
    border-radius: 1.45rem;
    background: rgba(255, 255, 255, 0.78);
    box-shadow: 0 16px 32px rgba(148, 163, 184, 0.14);
}

.listener-artists__main {
    min-width: 0;
    border: 0;
    padding: 0;
    background: transparent;
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
    gap: 0.75rem;
    align-items: center;
    text-align: left;
}

.listener-artists__image {
    width: 3.8rem;
    height: 3.8rem;
    object-fit: cover;
    border-radius: 1.1rem;
}

.listener-artists__meta {
    min-width: 0;
}

.listener-artists__name,
.listener-artists__sub {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.listener-artists__name {
    font-size: 0.95rem;
    font-weight: 700;
    color: #111827;
}

.listener-artists__sub {
    margin-top: 0.3rem;
    font-size: 0.8rem;
    color: #64748b;
}

.listener-artists__play {
    width: 2.8rem;
    height: 2.8rem;
    border: 0;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #111827;
    color: #fff;
    box-shadow: 0 12px 24px rgba(15, 23, 42, 0.2);
}

.listener-artists__play svg {
    width: 1rem;
    height: 1rem;
}

.listener-artists__empty,
.listener-artists__state {
    padding: 2.4rem 1rem 1rem;
    text-align: center;
    color: #64748b;
}

.listener-artists__empty h2 {
    margin-top: 0.85rem;
    font-size: 1.15rem;
    font-weight: 700;
    color: #111827;
}

.listener-artists__empty p,
.listener-artists__state p {
    margin-top: 0.45rem;
    font-size: 0.84rem;
    line-height: 1.6;
}

.listener-artists__empty-icon {
    width: 3.6rem;
    height: 3.6rem;
    margin: 0 auto;
    border-radius: 1.3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.9);
    color: #94a3b8;
    box-shadow: 0 16px 32px rgba(148, 163, 184, 0.14);
}

.listener-artists__empty-icon svg {
    width: 1.6rem;
    height: 1.6rem;
}

.listener-artists__loading {
    width: 2.4rem;
    height: 2.4rem;
    margin: 0 auto;
    border-radius: 999px;
    border: 3px solid rgba(148, 163, 184, 0.24);
    border-top-color: #111827;
    animation: listener-artists-spin 0.75s linear infinite;
}

@keyframes listener-artists-spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
